import { Box, Grid, Link, Typography } from "@mui/material";
import { Container, useTheme } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Offcanvas } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import berglogo from "../../../assets/images/bergfooter.png";
import call from "../../../assets/images/Callinglight.png";
import mail from "../../../assets/images/Maillight.png";
import location from "../../../assets/images/Locationlight.png";
import taxes from "../../../assets/images/Vatnew.png";
import wazin from "../../../assets/images/wazinen.png";
import wazinar from "../../../assets/images/wazinar.png";

import { useDispatch, useSelector } from "react-redux";
import Loader from "../../shared/Loader";
import { fetchContactData } from "../../../redux/slices/ContactSlice";
export default function ResponsiveFooter() {
  const [imageSrc, setImageSrc] = useState(wazin);

  const theme = useTheme();
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  const [drawerContent, setDrawerContent] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (currentLang === "ar") {
      setImageSrc(wazinar);
    } else {
      setImageSrc(wazin);
    }
  }, [currentLang]);

  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.Contact);

  useEffect(() => {
    dispatch(fetchContactData());
  }, [dispatch]);

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }
  const privacyData = data?.data?.static_pages;

  const handleTitleClick = (content) => {
    setDrawerContent(content);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <>
      <Box
        sx={{
          textAlign: "center",
          backgroundColor: "#061332",
          py: 6,
          px: { xs: "10px", lg: "119px" },
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: { xs: 4, sm: 0 },
            flexDirection: { md: "row", lg: "row-reverse" },
          }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            // md={3}
            lg={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "baseline",
              mb: 2,
              justifyContent: "space-between",
              height: { xs: "", md: "185px" },
              order: { xs: 4, md: 4, lg: 1 },
            
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "5px",
              }}
            >
              <img
                src={taxes}
                loading="lazy"
                alt="taxes"
                width="64"
                height="81"
                style={{
                  maxWidth: "64px",
                  height: "81px",
                  borderRadius:"5px"
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  gap: currentLang === "ar" ? {xs:1,md:0} : {xs:1,md:0},
                }}
              >
                <Typography
                  textAlign={currentLang === "ar" ? "right" : "left"}
                  sx={{ color: "#FFFFFF", fontSize: "14px", fontWeight: "400" }}
                >
                  {data?.data?.settings?.company_name[currentLang]}
                </Typography>
                <Typography
                  textAlign={currentLang === "ar" ? "right" : "left"}
                  sx={{ color: "#FFFFFF", fontSize: "14px", fontWeight: "400" }}
                >
                  {t("missed.Commercial-Registration")}{" "}
                  {data?.data?.settings?.commercial_register}
                </Typography>
                <Typography
                  textAlign={currentLang === "ar" ? "right" : "left"}
                  sx={{ color: "#FFFFFF", fontSize: "14px", fontWeight: "400" }}
                >
                  {t("missed.Tax-Number")} {data?.data?.settings?.tax_number}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            // md={3}
            lg={2.5}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 1.5,
              order: { xs: 3, md: 3, lg: 3 },
              mb: 2,

            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "20px",
                color: "#FFFFFF",
              }}
            >
              {t("missed.Contact info")}
            </Typography>

            <Link
              href={`tel:${data?.data?.settings?.phone1}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 1,
                  gap: 1,
                }}
              >
                <img
                  src={call}
                  loading="lazy"
                  alt="call"
                  width="150"
                  height="100"
                  style={{
                    maxWidth: "24px",
                    height: "24px",
                  }}
                />

                <Typography sx={{ color: "#BCC3C7", fontWeight: "400" }}>
                  {data?.data?.settings?.phone1}
                </Typography>
              </Box>
            </Link>
            <Link
              href={`mailto:${data?.data?.settings?.email}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 1,
                  gap: 1,
                }}
              >
                <img
                  src={mail}
                  loading="lazy"
                  alt="mail"
                  style={{ maxWidth: "150px" }}
                />
                <Typography sx={{ color: "#BCC3C7", fontWeight: "400" }}>
                  {data?.data?.settings?.email}
                </Typography>
              </Box>
            </Link>
            <Link
              href={`https://www.google.com/maps?q=:${data?.data?.settings?.location[currentLang]}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginTop: 1,
                  gap: 1,
                }}
              >
                <img
                  src={location}
                  loading="lazy"
                  alt="location"
                  width="150"
                  height="100"
                  style={{
                    maxWidth: "24px",
                    height: "24px",
                  }}
                />
                <Typography
                  sx={{
                    color: "#BCC3C7",
                    fontWeight: "400",
                    textAlign: currentLang === "ar" ? "right" : "left",
                  }}
                >
                  {data?.data?.settings?.location[currentLang]}
                </Typography>
              </Box>
            </Link>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            // md={2}
            lg={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 1.5,
              order: { xs: 2, md: 2, lg: 2 },
              mb: 2,

            }}
          >
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "20px",
                color: "#FFFFFF",
              }}
            >
              {t("missed.Other resources")}
            </Typography>
            {privacyData?.map((item, index) => (
              <Typography
                key={index}
                sx={{
                  color: "#BCC3C7",
                  fontWeight: "400",
                  cursor: "pointer",
                }}
                onClick={() => handleTitleClick(item.content[currentLang])}
              >
                {item.title[currentLang]}
              </Typography>
            ))}
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            // md={4}
            lg={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 1,
              order: { xs: 1, md: 1, lg: 4 },
              mb: { xs: 4, md: 4 },
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <img
                src={berglogo}
                loading="lazy"
                alt="berglogo"
                width="150"
                height="100"
                style={{
                  maxWidth: "150px",
                  height: "auto",
                }}
              />
            </Box>

            <Typography
              sx={{
                color: "#FFFFFF",
                fontWeight: "400",
                width: "90%",
                textAlign: currentLang === "ar" ? "right" : "left",
                fontSize: "16px",
              }}
            >
              {data?.data?.settings?.footer_description[currentLang]}{" "}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Container maxWidth={"lg"}>
        <Grid
          container
          sx={{
            borderTop: "1px solid",
            borderImage:
              "linear-gradient(to right, rgba(187, 215, 252, 0) 10%, #BBD7FC33 20%, #07489D66 40%, #BBD7FC33 80%, rgba(187, 215, 252, 0) 60%) 1",
            pt: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 5, sm: 0 },
            py: 3,
          }}
        >
          <Typography
            sx={{
              marginTop: "10px",
              color: theme.palette.primary.body,
              fontWeight: "400",
              fontSize: "16px",
            
            }}
          >
            {t("missed.All-rights")}
          </Typography>

          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 1,
              alignItems: "end",
            }}
            component="a"
            href="https://www.wazin.sa/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Typography
              sx={{
                color: theme.palette.primary.body,
                fontWeight: "400",
                fontSize: "16px",
              }}
            >
              {t("missed.made")}
            </Typography>
            <img
              src={imageSrc}
              loading="lazy"
              alt="wazin"
              width="65"
              height="24"
              style={{
                width: "65px",
                height: "24px",
              }}
            />
          </Box> */}
        </Grid>
      </Container>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement={currentLang === "ar" ? "end" : "start"}
        className="custom-offcanvas"
      >
        <Offcanvas.Header className="custom-header">
          <Offcanvas.Title className="custom-title">
            {
              privacyData?.find(
                (item) => item.content[currentLang] === drawerContent
              )?.title[currentLang]
            }
          </Offcanvas.Title>
          <CloseIcon className="custom-close-icon" onClick={handleClose} />
        </Offcanvas.Header>
        <Offcanvas.Body className="custom-body">
          <div dangerouslySetInnerHTML={{ __html: drawerContent }} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
